import Docs from '@/components/About/Docs';
import Layout from '@/components/Layout';
import API from '../api';
import { Container } from '@/components/ui/Grid';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import {getServerSidePaths} from "@/pages/contacts/[slug]";

// Заглушка для переводов
const translate = s => s;

const DocsPage = ({ data }) => {
  return (
    <Container>
      <Docs data={data} />
    </Container>
  );
};

const breadcrumbs = [
  { title: translate('Главная'), route: '/' },
  { title: translate('Документы'), route: '/documents' },
];

DocsPage.getLayout = (page, t) => (
  <Layout page={page.props} breadcrumbs={breadcrumbs} title={t('Документы — UNIFROST')}>
    {page}
  </Layout>
);

export async function getServerSideProps(context) {
  const props = { data: [] };

  try {
    const resDocs = await API.get(`/v1/api/documents/`, {
      headers: { 'Accept-Language': context.locale },
    });

    if (resDocs.status === 200 && Array.isArray(resDocs.data)) {
      if (resDocs.data) props.data = resDocs.data;
    }
  } catch (error) {}

  return {
    props: {
      ...props,
      ...(await serverSideTranslations(context.locale, ['common', 'menu'])),
    },
    // revalidate: 60,
  };
}

export default DocsPage;
